// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__vW-Vx","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__cIljt"};